import lang from '../../../../lib/language';
import { formatNumber } from '../../../../lib/util/DataHelpers';

import styles from './styles.module.scss';

type Props = {
  sorExecutedQuantity: number,
  totalQuantity: number,
  className: string | undefined,
  isMobile?: boolean;
}

const PendengOrdersQuantity = ({ sorExecutedQuantity, totalQuantity, className, isMobile }: Props) => (
  <>
    {sorExecutedQuantity && sorExecutedQuantity < totalQuantity ? (
      <div className={styles.partialFillWrapper}>
        <div>
          <span>{`${sorExecutedQuantity} / ${totalQuantity.toString()}`}</span>
        </div>
        <p className={styles.dot}>•</p>
        <div className={className}>{lang.commonMyAccountPendingOrdersPartiallFill()}</div>
      </div>
    ) : (
      <>{!isMobile && <div>{formatNumber(totalQuantity, true)}</div>}</>
    )}
  </>
);

export default PendengOrdersQuantity;
